import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";
// @ts-nocheck

/**
 * External dependencies
 */
import classnames from 'classnames';

const ColorIndicator = _ref => {
  let {
    className,
    colorValue,
    ...props
  } = _ref;
  return createElement("span", _extends({
    className: classnames('component-color-indicator', className),
    style: {
      background: colorValue
    }
  }, props));
};

export default ColorIndicator;
//# sourceMappingURL=index.js.map